import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';
import { ensurePostHog, getPostHog, queuePostHogCall } from './posthog-lazy';

function sendToPostHog(metric: Metric) {
  try {
    const properties = {
      metric_name: metric.name,
      metric_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      metric_rating: metric.rating,
      metric_id: metric.id,
      page_path: window.location.pathname,
    };
    const ph = getPostHog();
    if (ph) {
      ph.capture('web_vital', properties);
      return;
    }
    queuePostHogCall({ kind: 'capture', event: 'web_vital', properties });
    // Trigger the lazy load so queued vitals drain into PostHog once it lands.
    void ensurePostHog().catch(() => { /* PostHog not ready — skip silently */ });
  } catch {
    // PostHog not ready — skip silently
  }
}

export function reportWebVitals() {
  onCLS(sendToPostHog);
  onFCP(sendToPostHog);
  onINP(sendToPostHog);
  onLCP(sendToPostHog);
  onTTFB(sendToPostHog);
}
